import React from 'react';
import { translate } from 'react-i18next';

class ScheduleSelectedDay extends React.Component {

  static exchangeArrowPath() {
    const brand = window.EmployeeWeb.ENVConfig.brand
    if (brand === 'cerner') {
      return `/images/exchange-arrow-cerner.svg`;
    }
    return `/images/exchange-arrow.svg`;
  }

  constructor(props) {
    super(props);

    const curDate = moment(this.props.date).toDate() || moment(Date.now()).toDate();

    this.exchangeArrowPath = ScheduleSelectedDay.exchangeArrowPath();

    this.state = {
      date: curDate,
    };
  }

  updateDate(newDate) {
    this.setState({
      date: newDate,
    });
  }


  render() {
    // This isn't my favourite way of doing conditional rendering,
    // but without an overhaul it'll have to do.
    let selectedDayObj = null;
    if (this.props.date) {
      const selectedDate = moment(this.props.date).toDate() || moment(Date.now()).toDate();
      const containerClasses = (this.props.openSidebar || (!this.props.openSidebar && this.props.openCoworkerSidebar)) ? 'open' : '';
      let validExchange = null;
      if (!Utils.isNotDefined(this.props.selectedExchangeShift)) {
        validExchange = Utils.getFirstActiveExchange(this.props.selectedExchangeShift.exchanges);
      }
      const dropMyExchange = !!(!Utils.isNotDefined(validExchange) && validExchange.drop == true);
      const exchangeState = !Utils.isNotDefined(this.props.selectedExchangeShift)
        && !Utils.isNotDefined(this.props.selectedExchangeShift.state)
        ? this.props.selectedExchangeShift.state
        : 'new';
      let exchangeTypeLabel = this.props.openCoworkerSidebar
        ? this.props.t('ScheduleSelectedDay.who_is_working', { date: ['en', 'en_ca'].includes(Utils.getLocale()) ? moment(selectedDate).format('MMMM D') : moment(selectedDate).format('D MMMM') })
        : this.props.exchangeType == 'drop' || dropMyExchange
          ? this.props.t('ScheduleSelectedDay.drop_details')
          : this.props.exchangeType == 'my exchange'
            ? this.props.t('ScheduleSelectedDay.exchange_details')
            : this.props.t('ScheduleSelectedDay.select_shift_to_exchange');
      exchangeTypeLabel = exchangeState == 'accepted' ? this.props.t('ScheduleSelectedDay.accepted_exchange_details') : exchangeTypeLabel;

      selectedDayObj = (
        <div id="selected-day-container">
          <div id="selected-day-meta-container" className={containerClasses}>
            <div>
              <h2>{
                ['en', 'en_ca'].includes(Utils.getLocale()) 
                  ? moment(selectedDate).format('MMM DD, YYYY')
                  : moment(selectedDate).format('DD MMM YYYY').replace(/\./g, '')
              }</h2>
              <p>{moment(selectedDate).format('dddd')}</p>
            </div>
            {!_.isEmpty(this.props.selectedDayData) && Utils.getCoreUser() && Utils.getCoreUser().company.allow_who_is_working &&
              <button 
                className="who-is-working-button" 
                onClick={this.props.toggleCoworkerSidebar}
              >
                <img alt="who is working" src="/images/who-is-working.svg" />
              </button>
            }
          </div>
          <div
            id="selected-exchange-back-button"
            className={containerClasses}
            onClick={this.props.openCoworkerSidebar ? this.props.toggleCoworkerSidebar : this.props.toggleOpenSidebar}
          >
            <span className="exchange-arrow">
              <img alt="arrow symbol" src={this.exchangeArrowPath} />
            </span>
            <h2>{exchangeTypeLabel}</h2>
          </div>
        </div>
      );
    }

    return <div>{selectedDayObj}</div>;
  }
}

export default translate()(ScheduleSelectedDay);
